"use client";

import React from "react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Loader2, Clock, ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";
function ContactFormInner() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div data-section-id="102275" className="flex flex-col items-center justify-center py-16 text-center space-y-6 animate-in fade-in duration-700">
        <div className="size-20 rounded-full bg-primary/10 flex items-center justify-center mb-2">
          <Clock className="size-10 text-primary" />
        </div>
        <h3 className="text-3xl font-light text-foreground tracking-wide font-display">Mensaje Recibido</h3>
        <p className="text-muted-foreground max-w-md text-lg font-light leading-relaxed">{successMessage}</p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-8">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <FormField control={control} name="name" rules={{
        required: "El nombre es obligatorio"
      }} render={({
        field
      }) => <FormItem className="relative pt-5">
              <FormControl>
                <Input {...field} placeholder=" " className="peer h-10 border-x-0 border-t-0 border-b-2 border-muted bg-muted-light-background px-0 py-2 rounded-lg focus-visible:ring-0 focus-visible:border-b-primary text-foreground shadow-none text-base transition-colors" />
              </FormControl>
              <FormLabel className="absolute left-0 top-7 text-muted-foreground transition-all duration-300 peer-focus:top-0 peer-focus:text-xs peer-focus:text-primary peer-[:not(:placeholder-shown)]:top-0 peer-[:not(:placeholder-shown)]:text-xs peer-[:not(:placeholder-shown)]:text-muted-foreground pointer-events-none font-light tracking-wide">
                Nombre Completo
              </FormLabel>
              <FormMessage className="text-xs text-accent" />
            </FormItem>} />
        <FormField control={control} name="email" rules={{
        required: "El email es obligatorio",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Email no válido"
        }
      }} render={({
        field
      }) => <FormItem className="relative pt-5">
              <FormControl>
                <Input {...field} type="email" placeholder=" " className="peer h-10 border-x-0 border-t-0 border-b-2 border-muted bg-muted-light-background px-0 py-2 rounded-lg focus-visible:ring-0 focus-visible:border-b-primary text-foreground shadow-none text-base transition-colors" />
              </FormControl>
              <FormLabel className="absolute left-0 top-7 text-muted-foreground transition-all duration-300 peer-focus:top-0 peer-focus:text-xs peer-focus:text-primary peer-[:not(:placeholder-shown)]:top-0 peer-[:not(:placeholder-shown)]:text-xs peer-[:not(:placeholder-shown)]:text-muted-foreground pointer-events-none font-light tracking-wide">
                Correo Electrónico
              </FormLabel>
              <FormMessage className="text-xs text-accent" />
            </FormItem>} />
      </div>

      <FormField control={control} name="phone" render={({
      field
    }) => <FormItem className="relative pt-5">
            <FormControl>
              <Input {...field} type="tel" placeholder=" " className="peer h-10 border-x-0 border-t-0 border-b-2 border-muted bg-muted-light-background px-0 py-2 rounded-lg focus-visible:ring-0 focus-visible:border-b-primary text-foreground shadow-none text-base transition-colors" />
            </FormControl>
            <FormLabel className="absolute left-0 top-7 text-muted-foreground transition-all duration-300 peer-focus:top-0 peer-focus:text-xs peer-focus:text-primary peer-[:not(:placeholder-shown)]:top-0 peer-[:not(:placeholder-shown)]:text-xs peer-[:not(:placeholder-shown)]:text-muted-foreground pointer-events-none font-light tracking-wide">
                Teléfono <span className="text-muted-foreground/60 text-xs ml-1">(Opcional)</span>
            </FormLabel>
            <FormMessage className="text-xs text-accent" />
          </FormItem>} />

      <FormField control={control} name="inquiry_type" render={({
      field
    }) => <FormItem className="relative pt-5">
            <FormControl>
              <div className="relative">
                <select {...field} className="peer h-10 w-full border-x-0 border-t-0 border-b-2 border-muted bg-muted-light-background px-0 py-2 text-foreground focus:border-primary focus:outline-none focus:ring-0 appearance-none rounded-lg shadow-none text-base cursor-pointer transition-colors">
                  <option value="" disabled hidden></option>
                  <option value="Sesión Individual" className="bg-background text-foreground">Sesión Individual</option>
                  <option value="Programa de Coaching" className="bg-background text-foreground">Programa de Coaching</option>
                  <option value="Taller Grupal" className="bg-background text-foreground">Taller Grupal</option>
                  <option value="Otra consulta" className="bg-background text-foreground">Otra consulta</option>
                </select>
                <div className="absolute right-0 top-1/2 -translate-y-1/2 pointer-events-none text-muted-foreground peer-focus:text-primary transition-colors">
                  <ChevronDown className="size-5" strokeWidth={1.5} />
                </div>
              </div>
            </FormControl>
            <FormLabel className={cn("absolute left-0 transition-all duration-300 pointer-events-none font-light tracking-wide", field.value ? "top-0 text-xs text-muted-foreground" : "top-7 text-base text-muted-foreground", "peer-focus:top-0 peer-focus:text-xs peer-focus:text-primary")}>
              Motivo de la Consulta
            </FormLabel>
            <FormMessage className="text-xs text-accent" />
          </FormItem>} />

      <FormField control={control} name="message" rules={{
      required: "El mensaje es obligatorio"
    }} render={({
      field
    }) => <FormItem className="relative pt-5">
            <FormControl>
              <Textarea {...field} placeholder=" " className="peer min-h-[140px] resize-none border-x-0 border-t-0 border-b-2 border-muted bg-muted-light-background px-0 py-2 rounded-lg focus-visible:ring-0 focus-visible:border-b-primary text-foreground shadow-none text-base transition-colors" />
            </FormControl>
            <FormLabel className="absolute left-0 top-7 text-muted-foreground transition-all duration-300 peer-focus:top-0 peer-focus:text-xs peer-focus:text-primary peer-[:not(:placeholder-shown)]:top-0 peer-[:not(:placeholder-shown)]:text-xs peer-[:not(:placeholder-shown)]:text-muted-foreground pointer-events-none font-light tracking-wide">
              Cuéntame un poco sobre ti y tus objetivos
            </FormLabel>
            <FormMessage className="text-xs text-accent" />
          </FormItem>} />

      {submitError && <div className="p-4 bg-accent/10 border border-accent/20 rounded-lg">
          <p className="text-accent text-sm font-light">{submitError}</p>
        </div>}

      <div className="pt-4">
        <Button type="submit" disabled={isSubmitting} className="w-full bg-primary hover:bg-primary-hover text-foreground-primary font-bold text-lg h-16 rounded-lg relative overflow-hidden group border-none transition-all uppercase tracking-widest shadow-soft hover:shadow-medium">
          <span className="relative z-10 flex items-center justify-center gap-3">
            {isSubmitting && <Loader2 className="size-5 animate-spin" />}
            {isSubmitting ? 'Enviando...' : 'Enviar Solicitud'}
          </span>
          <div className="absolute inset-0 -translate-x-[150%] animate-[sweep_5s_infinite] bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-[-20deg]" />
        </Button>
      </div>
    </Form>;
}
export default function ContactForm() {
  return <section id="filtro" className="bg-background py-24 md:py-32 px-6 relative overflow-hidden">
      <style>{`
        @keyframes sweep {
          0% { transform: translateX(-150%) skewX(-20deg); }
          15% { transform: translateX(150%) skewX(-20deg); }
          100% { transform: translateX(150%) skewX(-20deg); }
        }
      `}</style>
      
      <div className="max-w-[800px] mx-auto flex flex-col md:flex-row gap-16 md:gap-12 items-start">
        <div className="flex-1 w-full">
          <FormProvider formKey="filter_form_programaclaridad" formId="filter_form_programaclaridad" sectionName="FILTRO" defaultValues={{
          name: "",
          email: "",
          phone: "",
          inquiry_type: "",
          message: ""
        }} validationRules={{
          name: {
            required: true
          },
          email: {
            required: true,
            pattern: "email"
          },
          message: {
            required: true
          }
        }} submitText="Enviar Solicitud" successMessage="Gracias por tu interés. Revisaré tu solicitud y te responderé personalmente en menos de 24 horas." className="w-full">
            <ContactFormInner />
          </FormProvider>
        </div>
        
        <div className="w-full md:w-56 flex-shrink-0 border-l border-muted pl-6 py-2 md:mt-6">
          <p className="italic text-muted-foreground text-sm leading-relaxed font-light">
            <span className="block text-primary not-italic font-display font-semibold mb-3 text-xs tracking-widest uppercase">Nota de la Coach</span>
            Tu camino hacia el cambio comienza aquí. Revisaré cada detalle de tu mensaje para ofrecerte la mejor guía posible desde nuestro primer contacto.
          </p>
        </div>
      </div>
    </section>;
}